import { render } from "./PassBuyBox.vue?vue&type=template&id=07d0d897"
import script from "./PassBuyBox.vue?vue&type=script&lang=js"
export * from "./PassBuyBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/single/PassBuyBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07d0d897"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07d0d897', __exports__)) {
    api.reload('07d0d897', __exports__)
  }
  
  module.hot.accept("./PassBuyBox.vue?vue&type=template&id=07d0d897", () => {
    api.rerender('07d0d897', render)
  })

}


export default __exports__